import { RightFillIcon } from "@t8891/icon";
import cx from "classnames";
import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import styles from "./index.module.less";
import CarItem from "../CarItem";


interface IProps {
  itemCss?: React.CSSProperties | undefined;
  iconCss?: React.CSSProperties | undefined;
  titleCss?: React.CSSProperties | undefined;
  boxCss?: React.CSSProperties | undefined;
  itemTitleLineClamp?: number;
  scrollToNum: number;
  dataSource: {
    movies: Movie[];
    title: string;
    total?: number;
    description?: string;
  };
  type: number;
  moreHref?: string;
  likeIconShow?: boolean;
  maxLength?: number;
  urlParams?: string;
  isShowScroll?: boolean;
  onClick?: (e: any) => void;
  onExposured?: (e: any) => void;
}

export interface Movie {
  id: number;
  likes: string | number;
  link: string;
  thumb: string;
  title: string;
  type: number;
  views: string | number;
}

const HotVideo: React.FC<IProps> = ({
  dataSource,
  type,
  itemCss,
  iconCss,
  scrollToNum,
  titleCss,
  boxCss,
  moreHref,
  likeIconShow,
  itemTitleLineClamp,
  maxLength = 4,
  isShowScroll = true,
  urlParams,
  onClick,
  onExposured,
}) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [left, setLeft] = useState<boolean>(true);
  const [right, setRight] = useState<boolean>(true);

  const scrollTo = useCallback((scrollValue) => {
    if (!isShowScroll) return;
    let scrollLeft = targetRef.current!.scrollLeft;
    targetRef.current!.scrollTo(scrollLeft + scrollValue, 0);
  }, []);

  const onScroll = useCallback((e) => {
    if (!isShowScroll) return;
    const scrollLenght = targetRef.current!.scrollWidth - 1190;
    let scrollLeft = e?.currentTarget?.scrollLeft;

    setRight(scrollLeft === scrollLenght);
    setLeft(scrollLeft === 0);
  }, []);

  useEffect(() => {
    if (dataSource.movies.length === 0) return;
    targetRef.current!.addEventListener("scroll", onScroll);

    dataSource.movies.length > maxLength ? setRight(false) : setRight(true);

    return () => {
      targetRef.current!.removeEventListener("scroll", onScroll);
    };
  }, [dataSource]);

  return (
    <div className={cx(styles["hot-video"])} style={boxCss}>
      {dataSource.title && (
        <>
          <div className={styles["title"]} style={titleCss}>
            {dataSource.title}
            {dataSource.total && type === 1 && (
              <a href={moreHref} className={styles["total"]}>
                共<span>{dataSource.total}</span>
                {`${dataSource.title === "業代配備詳解" ? "款車" : "隻影片"}`}
                <RightFillIcon size={16} fill={"#333333"} />
              </a>
            )}
            {type === 2 && moreHref != "" && <a href={moreHref}>更多</a>}
          </div>
          {dataSource.description && (
            <p className='w-full h-20 text-14 text-gray-500 leading-20 -mt-8 mb-20'>{dataSource.description}</p>
          )}
        </>
      )}

      {!left && <i className={styles["left-icon"]} style={iconCss} onClick={() => scrollTo(-scrollToNum)} />}
      {!right && <i className={styles["right-icon"]} style={iconCss} onClick={() => scrollTo(scrollToNum)} />}

      <div className={styles["brand-scroll"]} ref={targetRef}>
        {Array.isArray(dataSource.movies) &&
          dataSource.movies.length > 0 &&
          dataSource.movies.map((item: any, index) => (
            <CarItem
              data={item}
              key={index}
              itemTitleLineClamp={itemTitleLineClamp}
              className={styles["scroll-item"]}
              style={{
                ...itemCss,
                marginRight: index + 1 === dataSource.movies.length ? "" : itemCss?.marginRight || "",
              }}
              likeIconShow={likeIconShow}
              urlParams={urlParams}
              onClickItem={() => onClick && onClick(item)}
              onExposuredItem={() => onExposured && onExposured(item)}
            />
          ))}
      </div>
    </div>
  );
};
export default memo(HotVideo);
